import React from 'react';

const UpdateVariablesModal = ({
  isVisible,
  x,
  y,
  z,
  setX,
  setY,
  setZ,
  onSave,
  onClose,
  inputError,
  setInputError,
}) => {
  if (!isVisible) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content modal-glass-avatar">
          <div className="modal-header">
            <h5 className="modal-title-update-variable">Update Variables</h5>
          </div>
          <div className="modal-body">
            <div className='row'>
              <div className='col-md-6'>
                <label>
                  Integer X:
                  <input
                    type="number"
                    className="form-control custom-input"
                    value={x}
                    onChange={(e) => setX(parseInt(e.target.value))}
                  />
                </label>
              </div>
              <div className='col-md-6'>
                <label>
                  Float Y:
                  <input
                    type="number"
                    className="form-control custom-input"
                    value={y}
                    onChange={(e) => setY(parseFloat(e.target.value))}
                  />
                </label>
              </div>
            </div>
            <div className='row' style={{paddingTop: '20px'}}>
              <div className='col-md-6'>
                <label>
                  Complex Z:
                  <input
                    type="text"
                    className="form-control custom-input"
                    value={z}
                    onChange={(e) => {
                      const value = e.target.value;
                      const complexNumberRegex = /^\s*[-+]?\d+(\.\d+)?\s*([-+]\s*\d+(\.\d+)?j)?\s*$/i;
                      if (value === '' || complexNumberRegex.test(value)) {
                        setInputError("");
                      } else {
                        setInputError("Not a valid complex value.");
                      }
                      setZ(value);
                    }}
                  />
                </label>
              </div>
            </div>
            {inputError.length > 0 ?
              <div className='row'>
                <label className='text-danger'>{inputError}</label>
              </div>
              : null
            }
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-dark"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={onSave}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateVariablesModal;
